import { BOOLEAN, NUMBER, NUMBER_CSV, STRING, STRING_CSV } from './utils';
import {
  getBooleanOverride,
  getNumberListOverride,
  getNumberOverride,
  getStringListOverride,
  getStringOverride,
} from './frontend-config-overrides';
import { maybe } from 'true-myth';

export const getNumberConfig = (name: string, defaultVal: number) =>
  getNumberOverride(name) ??
  NUMBER()
    .andThen((number) => maybe.of(number[name]))
    .unwrapOr(defaultVal);

export const getStringConfig = (name: string, defaultVal: string) =>
  getStringOverride(name) ??
  STRING()
    .andThen((string) => maybe.of(string[name]))
    .unwrapOr(defaultVal);

export const getBooleanConfig = (name: string, defaultVal: boolean) =>
  getBooleanOverride(name) ??
  BOOLEAN()
    .andThen((boolean) => maybe.of(boolean[name]))
    .unwrapOr(defaultVal);

export const getStringListConfig = (name: string, defaultVal: Array<string>) =>
  getStringListOverride(name) ??
  STRING_CSV()
    .andThen((stringCsv) => maybe.of(stringCsv[name]))
    .map((csv) => csv.split(','))
    .unwrapOr(defaultVal);

export const getNumberListConfig = (name: string, defaultVal: Array<number>) =>
  getNumberListOverride(name) ??
  NUMBER_CSV()
    .andThen((numberCsv) => maybe.of(numberCsv[name]))
    .map((csv) => csv.split(',').map(Number))
    .unwrapOr(defaultVal);
